<script>
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import notify from "../../../../../Script/notify"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import BadgePublish, { updateBadgePublish } from "../../Stores/badge"
  import Header from "../../Components/header.svelte"
  import Table from "../../../../../Shared/Table/table.svelte"
  import List from "./Components/list.svelte"
  import Filter from "../../../../../Shared/filter.svelte"
  import { fetchDocTempList, fetchSingleDocTempDetails } from "../../Script/api"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoading = true
  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Fetching Document templates"
  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {Object} - it consists response of Document template fetch api
   */
  let docTempdata = {}

  /**
   * @type {String} - what type of sort applied
   */
  let sortBy

  /**
   * @type {String} - what type of sort applied
   */
  let findPageRefreshed = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * Assign initial values
   */
  onMount(async () => {
    // setTimeout(async () => {
    try {
      showLoading = true
      // console.log("onMount")
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.sname) search.searchvalue = query.sname

      if (!findPageRefreshed) await handleDocumentListFetch()
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Choose Document Template)\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
    // }, 100)
  })

  const handleDocumentListFetch = async () => {
    try {
      let queryStr = `?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`

      docTempdata = await fetchDocTempList(queryStr)

      push(`/publish/badge/doctemplate?documentId=${$BadgePublish.documentId}&badgeId=${$BadgePublish.badgeId}&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  /**
   * @description function goto metadata section.
   */
  const nextPage = async (id) => {
    try {
      // console.log("nextPage")
      closeNotification.close()

      msg = "Fetching metadata for selected Document template"
      showLoading = true

      let apiData = await fetchSingleDocTempDetails(id)

      if (!apiData.file) throw "Selected Document template doesn't linked with a File template"

      $BadgePublish.documentTemplateId = id
      $BadgePublish.metadata = JSON.parse(apiData.metadata)
      updateBadgePublish($BadgePublish)

      push(`/publish/badge/metadata?documentId=${$BadgePublish.documentId}&badgeId=${$BadgePublish.badgeId}`)
    } catch (error) {
      const info = "PAGE: Badge Publish (Choose Document Template)\nEVENT: While selecting document template to proceed"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      // console.log("change entries")
      showLoading = true
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await handleDocumentListFetch()
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Choose Document Template)\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      // console.log("reset")
      showLoading = true
      limit = 10
      page = 1
      sort = -1
      search.searchvalue = ""
      startDate = null
      endDate = null
      await handleDocumentListFetch()
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Upload or Select Badge)\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:window
  on:load={() => {
    findPageRefreshed = true
    push(`/publish/badge?documentId=${query.documentId}&badgeId=${query.badgeId}`)
  }}
/>

<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="mx-auto h-auto w-full max-w-[920px] px-6 pb-40 pt-6 lg:px-0">
    <Header title="Choose Document Template" bind:showLoading bind:msg />
    <div class="relative flex min-h-[470px] flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
      <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">Please select a document template from which data will be imported. This will help you save time for publishing the document by automatically populating certain fields with pre-existing data from the selected template.</p>
      <div class="h-full space-y-3">
        {#if docTempdata.templates}
          <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title="Document Templates" filterComponent={Filter} filter={true} jsonData={docTempdata.templates ? docTempdata.templates : []} count={docTempdata.count}>
            <!-- List component -->
            {#if docTempdata.templates.length}
              {#each docTempdata.templates as json}
                <List
                  {json}
                  on:click={() => {
                    nextPage(json.id)
                  }}
                />
              {/each}
            {:else}
              <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no Document template</div>
            {/if}
          </Table>
        {/if}
      </div>

      {#if docTempdata.templates && !docTempdata.templates.length}
        <div class="flex w-full justify-end">
          <a href="#/templates/document/edit?id=000000000000000000000000&documentID={$BadgePublish.documentId}&badgeId={$BadgePublish.badgeId}" type="button" class="flex h-9 w-fit min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
            <i class="fa-solid fa-plus" />
            <span class="select-none md:block">&nbsp;Create&nbsp;Document&nbsp;Template&nbsp;&nbsp;</span>
          </a>
        </div>
      {/if}
      {#if showLoading}
        <LoadingScreen {msg} />
      {/if}
    </div>
  </div>
  <Footer />
</div>
